<template>
<div class="product-detail-content" v-if="product">

  <!-- 顶部固定导航 -->
  <product-info-nav-tab
    v-show="showFixedNavBar"
    :nav-section-id="currentNavSectionId"
    :product="product"
    :nav-section-id-maps="navSectionIdMaps"
    @addOrderCalled="allAddOrder"
    @shareProduct="shareProduct"
    @scroll-to-section="scrollToSection"
  ></product-info-nav-tab>

  <!-- 顶部基本信息 -->
  <visa-top-infos
    :product="product"
    :peer="peer"
    :comment-total="commentTotal"
    ref="visaTopInfos"
    :from="from"
    :province_code="province_code"
    @scroll-to-section="scrollToSection"
  ></visa-top-infos>
  
  <!-- 受理范围 -->
  <visa-accept-range :product="product"></visa-accept-range>

  <!-- 办理须知 -->
  <visa-handle-instruction :product="product"></visa-handle-instruction>

  <!-- 办签资料 -->
  <visa-materials :product="product" :peer="peer"></visa-materials>

  <!-- 温馨提示 -->
  <visa-reminder :product="product"></visa-reminder>

  <!-- 办理流程 -->
  <processing-flow :product="product"></processing-flow>

  <!-- 退款政策 -->
  <visa-refund-policy :product="product"></visa-refund-policy>

  <!-- 拒签无忧 -->
  <reject-order-info v-if="User.isLogin()" :product-detail="product"></reject-order-info>

  <!-- 签证图例 -->
  <visa-example-page v-if="product.visa_page" :visa-page="product.visa_page"></visa-example-page>

  <!-- 常见问题 -->
  <common-questions :product="product" :country="product.visa_country_name" @getQaCount="getQaCount"></common-questions>

  <!-- 评价 -->
  <product-comment :product="product" :country="product.visa_country_name"></product-comment>

  <!-- 供应商地址变化 -->
  <supplier-express-address-change :product="product"></supplier-express-address-change>
</div>

</template>

<script>
import { mapState } from 'vuex';
import Http from '@/libs/http';
import User from '@/libs/user';
import askQuestion from '@/components/product/ask-question';
import utils from '@/libs/utils';
import commentApi from '@/api/product-comment-api';
import visaTopInfos from './components/visa-top-infos';
import productInfoNavTab from './components/product-info-nav-tab';
import visaMaterials from './components/visa-materials';
import processingFlow from './components/processing-flow';
import visaExamplePage from './components/visa-example-page';
import commonQuestions from './components/common-questions';
import ProductComment from './components/product-comment';
import supplierExpressAddressChange from './components/supplier-express-address-change';
import VisaRefundPolicy from './components/visa-refund-policy.vue';
import VisaAcceptRange from './components/visa-accept-range.vue';
import VisaReminder from './components/visa-reminder.vue';
import VisaHandleInstruction from './components/visa-handle-instruction.vue';
import RejectOrderInfo from './components/reject-order-info.vue';


export default {
  name: 'Product',
  components: {
    askQuestion,
    visaTopInfos,
    visaMaterials,
    processingFlow,
    ProductComment,
    commonQuestions,
    visaExamplePage,
    productInfoNavTab,
    supplierExpressAddressChange,
    VisaRefundPolicy,
    VisaAcceptRange,
    VisaReminder,
    VisaHandleInstruction,
    RejectOrderInfo,
  },
  props: {
    product: {
      type: Object,
      default() {
        return {};
      },
    },
    from: String,
    province_code: Number,
  },
  data() {
    return {
      currentNavSectionId: '#visa-top-infos',
      showFixedNavBar: false,
      peer: {},
      qaCount: 0,
      navSectionIdMaps: [],
      User,
      commentTotal: 0,
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  async created() {
    this.getPeerInfo();
    await this.getCommentList();
    this.init();
  },
  watch: {
    product() {
      this.init();
    },
  },
  methods: {
    init() {
      if (!this.product.visa_product_id) return;

      this.createNavIdMaps(this.product);
    },
    // 问题数量
    getQaCount(count) {
      this.qaCount = count;
    },

    // 分享商品
    shareProduct() {
      this.$refs.visaTopInfos.shareToCustomer();
    },

    // 顶部添加订单
    allAddOrder() {
      this.$refs.visaTopInfos.addOrderNow();
    },

    createNavIdMaps(product) {
      const arr = [
        { isQuestion: false, id: '#visa-top-infos', text: '基本信息' },
        { isQuestion: false, id: '#visa-handle-instruction', text: '办理须知' },
        { isQuestion: false, id: '#visa-materials', text: '资料清单' },
      ];
      
      arr.push({ isQuestion: false, id: '#processing-flow', text: '办签流程' });

      if (product.refund_policy && User.isLogin()) {
        arr.push({ isQuestion: false, id: '#visa-refund-policy', text: '退款政策' });
      }
 
      arr.push({ isQuestion: true, id: '#common-questions', text: '常见问题' });
      arr.push({ isQuestion: true, id: '#product-comment', text: `评价 （${this.commentTotal}）` });
      this.navSectionIdMaps = arr;
    },

    // 获取同业信息
    getPeerInfo() {
      if (User.isLogin()) {
        Http.post('/visa_peer_query').then((data) => {
          this.peer = data;
        });
      }
    },

    // 设置当前的导航id
    handleScroll() {

      // 页面距离顶部的滚动位置
      const pageScrollTop = utils.getPageScrollTop();

      // 导航栏的高度
      const navBarHeight = 84;
      const fixedNavBarHeight = document.querySelector('.product-info-nav-tab').offsetHeight;
      // 各个元素的距离顶部位置, -60 是为了减去fixedNav的高度
      const navElementToTops = this.navSectionIdMaps.map(map => document.querySelector(map.id).getBoundingClientRect().top + pageScrollTop);
      const acceptRangeTop = document.querySelector('.product-base-info').getBoundingClientRect().top + pageScrollTop;
      const currPageTop = pageScrollTop + navBarHeight + fixedNavBarHeight;


      // 是否显示，要超过受理范围才显示
      this.showFixedNavBar = currPageTop > acceptRangeTop;


      for (let i = 0; i < navElementToTops.length; i++) {

        // 如果不是最后一个，要在前后区域内
        if (i < navElementToTops.length - 1) {
          if (currPageTop >= navElementToTops[i] && navElementToTops[i + 1] > currPageTop) {
            this.currentNavSectionId = this.navSectionIdMaps[i].id;
          }
        } else {

          // 最后一个大于等于就好
          if (currPageTop >= navElementToTops[i]) {
            this.currentNavSectionId = this.navSectionIdMaps[i].id;
          }
        }
      }
    },

    // 滚动到评价模块
    scrollToSection(id) {
      try {
        utils.scrollToElement(id, 68 + document.querySelector('.product-info-nav-tab').offsetHeight + 16 - 2);
      } catch (error) {
        console.log(error);
      }
    },

    // 获取评价数量
    async getCommentList() {
      try {
        const params = {
          product_id: this.product.visa_product_id,
          page: 1,
        };
        const data = await commentApi.getCommentList(params);
        this.commentTotal = data.total_count;
      } catch (e) {
        console.log(e, '请求评价');
      }
    },

    
  },
};
</script>

<style lang="less" scoped>
.product-detail-content {
  flex-shrink: 0;
  width: 100%;
  position: relative;

}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/product-info.vue